(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["os-gift-buybox"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('os-gift-buybox')) {
  customElements.define('os-gift-buybox', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('change', () => this.update(), { signal: this.controller.signal });
      // Browsers restore radio selections after returning from flavor selection.
      window.addEventListener('pageshow', () => requestAnimationFrame(() => {
        if (this.isConnected) this.update();
      }), { signal: this.controller.signal });
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); }
    update() {
      const selected = this.querySelector('[data-offer-quantity]:checked');
      const once = this.querySelector('[data-offer-mode]:checked')?.value === 'once';
      if (!selected) return;
      const boxes = Number(selected.value);
      const heading = this.closest('.os-pdp').querySelector('[data-offer-heading]');
      if (heading) {
        heading.dataset.originalHeading ||= heading.textContent;
        heading.textContent = once ? 'Up to 27% off with a one-time purchase' : heading.dataset.originalHeading;
      }
      this.querySelectorAll('[data-offer-quantity]').forEach((input) => {
        const price = once ? input.dataset.oncePrice : input.dataset.price;
        const saving = once ? input.dataset.onceSaving : input.dataset.savings;
        input.closest('label').querySelector('[data-offer-price]').textContent = `$${price}/snack`;
        input.closest('label').querySelector('[data-offer-saving]').textContent = `Save ${saving}%`;
      });
      this.querySelector('.os-gift-buybox__gifts').hidden = once;
      this.querySelector('.os-gift-buybox__membership').hidden = once;
      this.querySelector('[data-offer-subscribe]').textContent = `Subscribe & Save ${selected.dataset.savings}%`;
      let value = 0, count = 0;
      this.querySelectorAll('[data-offer-gift]').forEach((gift) => {
        const unlocked = boxes >= Number(gift.dataset.offerGift);
        gift.querySelector('.os-gift-buybox__lock').hidden = unlocked;
        if (unlocked) { value += Number(gift.dataset.value); count++; }
      });
      this.querySelector('[data-offer-gift-value]').textContent = `🎁 $${value.toFixed(2)} of gifts with your first order! 🎁`;
      this.querySelector('[data-offer-summary]').textContent = once ? `Save ${selected.dataset.onceSaving}% with a one-time purchase` : `🎉 You save ${selected.dataset.savings}% with ${count} free gift${count === 1 ? '' : 's'} on your first order*`;
      const days = boxes >= 6 ? 45 : 30;
      this.querySelector('[data-offer-frequency]').textContent = `Every ${days} days, cancel easily`;
      this.querySelector('[data-offer-refill]').textContent = `✓ ${boxes}-box refill ships every ${days} days at $${boxes === 2 ? '14.97' : '14.03'}/box`;
      this.querySelector('[data-offer-shipping]').textContent = boxes >= 3 ? '✓ Free US shipping and gifts on your first shipment' : '✓ Free gifts on your first shipment; free US shipping at 3+ boxes';
      const link = this.querySelector('[data-offer-link]');
      const url = new URL(once ? '/pages/flavors-ot' : '/pages/flavors', location.origin);
      if (location.pathname === '/pages/find-us') {
        url.pathname = location.pathname;
        url.searchParams.set('view', once ? 'flavors-once' : 'flavors');
      }
      url.searchParams.set('from', this.dataset.sourceView || 'offer');
      url.searchParams.set('quantity', String(boxes));
      const params = new URLSearchParams(location.search);
      for (const [key, val] of params) {
        if (key.startsWith('utm_') || ['gclid', 'fbclid', 'preview_theme_id', 'pb'].includes(key)) url.searchParams.set(key, val);
      }
      link.href = url.href;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
